<template>
  <FormInput
    ref="input"
    :id="id"
    :name="name"
    :value="formattedValue"
    type="number"
    :placeholder="placeholder"
    :required="required"
    :disabled="disabled"
    :readonly="readonly"
    :maxlength="maxlength"
    :minlength="minlength"
    inputmode="decimal"
    :pattern="pattern"
    :label="label"
    :labelOption="labelOption"
    :icon="icon"
    :hint="hint"
    :error="error"
    :attributes="attributes"
    @keyup="onKeydown"
    @input="onInput"
  />
</template>

<script>
import FormInput from './FormInput.vue' // Assuming FormInput is in the same directory

export default {
  components: {
    FormInput,
  },
  props: {
    id: String,
    name: String,
    value: [Number, null],
    placeholder: String,
    required: Boolean,
    disabled: Boolean,
    readonly: Boolean,
    maxlength: Number,
    minlength: Number,
    pattern: String,
    label: String,
    labelOption: String,
    icon: String,
    hint: String,
    error: Boolean,
    attributes: {
      type: Object,
      default: () => ({
        step: 0.01,
        min: 0,
      }),
    },
  },
  model: {
		prop: 'value',
		event: 'input'
	},
  computed: {
    formattedValue() {
      return this.value !== null ? this.value / 100 : '';
    },
  },
  methods: {
    focus() {
      this.$refs?.input?.focus()
    },
    onKeydown(e) {
      const input = e.target
      const value = input.value
      const cursor = input.selecionStart

      if (value.toString().split('.')?.[1]?.length > 2) {
        input.value = Number(value).toFixed(2)
        input.selecionStart = cursor
      }
    },
    onInput(value) {
      this.$emit('input', Math.floor(value * 100));
    },
  },
};
</script>
